// extracted by mini-css-extract-plugin
export default {"main":"InformedConsent_main__oAP7b","content":"InformedConsent_content__2iD95"};